import { useEffect, useRef, useState } from "react";
import { getElements2, exportParamsFile_fg, uploadFile_fg, download_ } from '../../services/services';
import EditableTable from "../MyUI/EditableTable/EditableTable";
import { validateRows } from "../MyUI/EntityTableTemplate/validateEntity";
import FileInput from "../MyUI/FileInput/FileInput";

const uploadFileService = {
  upload: uploadFile_fg,
  services_url_names: {
    upload: "Parameters_File_Generator_Import",
  },
};
export default function ParametersFileGenerator() {
  const formRef = useRef();
  const [combboxElements, setCombboxElements] = useState([]);
  const [isExporting, setIsExporting] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [fileToUpload, setFileToUpload] = useState(null);
  const [error, setError] = useState("");

  const [params, setParams] = useState([{
    element_id: "",
    system_subsystem_element_description: "",
    HFI_or_LFI: "HFI",
    author: "",
    verified_by: "",
  }]);

  const [params2, setParams2] = useState([
    { second_id: 1, paramName: "", identity: "Functional" },
  ]);
  const [params3, setParams3] = useState([
    { second_id: 1, paramName: "Dimensions L (z axis)", identity: "Integration" },
    { second_id: 2, paramName: "Dimensions H (y axis)", identity: "Integration" },
    { second_id: 3, paramName: "Dimensions W (x axis)", identity: "Integration" },
    { second_id: 4, paramName: "Weight", identity: "Integration" },
    { second_id: 5, paramName: "Required Power", identity: "Integration" },
    { second_id: 6, paramName: "Required Water", identity: "Integration" },
    { second_id: 7, paramName: "Required Cryo", identity: "Integration" },
    { second_id: 8, paramName: "Required Gas", identity: "Integration" },
  ]);

  useEffect(() => {
    fetchElements2();
  }, []);

  const fetchElements2 = async () => {
      //setLoading(true);
      try {
        const res = await getElements2(
        {
        filters: [],
        pagen: 1,
        itemsPerPage: 1000,
        sortBy: '',
        sortDesc: false,
      });
      const list = res.data.params.map(p => ({
        label: `${p.element_name} ${p.pbscode}`,
        value: p.id
      }));
        setCombboxElements(list);
      } catch (err) {
        console.error(err);
        console.error('Error fetching elems:', error);
      } finally {
      //  setLoading(false);
      }
  };
  const HFI_LFI_OPTIONS = {
    HFI: "HFI",
    LFI: "LFI",
  };

  const Identity_OPTIONS = {
    HFI: "Functional",
    LFI: "Integration",
};


  const exportParamsFile = async () => {
    setIsExporting(true);
    setError("");

    const results1 = validateRows(params, defaultColumns1);
    const results2 = validateRows(params2, defaultColumns2);
    const results3 = validateRows(params3, defaultColumns3);

    const allInvalidFields = [
      ...results1.invalidFields,
      ...results2.invalidFields,
      ...results3.invalidFields,
    ];

    const allValid =
      results1.isValid &&
      results2.isValid &&
      results3.isValid;

    if (!allValid) {
      setError(
        "Invalid fields:\n" +
          allInvalidFields
            .map(f => `Row ${f.row + 1} - ${f.key}: ${f.message}`)
            .join("\n")
      );
      setIsExporting(false);
      return;
    }

    const selected = combboxElements.find(
      i => i.value === params[0].element_id
    );

    const parts = selected.label.split(" ");
    const pbsCode = parts[parts.length - 1];
    const [, second] = pbsCode.split(".");

    if (params[0].HFI_or_LFI === "LFI" && second === "1") {
      setError("LFI requires PBS second digit = 2");
      setIsExporting(false);
      return;
    }

    if (params[0].HFI_or_LFI === "HFI" && second === "2") {
      setError("HFI requires PBS second digit = 1");
      setIsExporting(false);
      return;
    }

    const payload = {
      data_infos0: {
        element_name: parts[0],
        pbscode: pbsCode,
        HFI_or_LFI: params[0].HFI_or_LFI,
      },
      data_infos: params,
      Functional_Parameters: params2,
      Integration_Parameters: params3,
    };
    try{
    const res = await exportParamsFile_fg(payload);

    const blob = new Blob([res.data], { type: 'application/octet-stream' });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    let filename = `BilanExport.txt`; // fallback

    const disposition = res.headers['content-disposition'];
    if (disposition && disposition.indexOf('filename=') !== -1) {
        filename = disposition
            .split('filename=')[1]
            .split(';')[0]
            .replace(/"/g, '')
            .trim();
      }
    a.download = filename;  // You can dynamically name it
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
    setIsExporting(false);
  }
    catch(err){

      console.error('Error Exporting:', err);
    }
    finally{
      setIsExporting(false);
    }
  };

  const requiredFields = ["paramName", "identity"];
// Validation
  const missingRequiredFields2 = params2.flatMap((row, rowIndex) =>
    requiredFields
      .filter((key) => !row[key])
      .map((key) => `${key} (row ${rowIndex + 1})`)
  );
  const missingRequiredFields3 = params3.flatMap((row, rowIndex) =>
    requiredFields
      .filter((key) => !row[key])
      .map((key) => `${key} (row ${rowIndex + 1})`)
  );

  const defaultColumns1 = [
    { key: 'element_id', label: 'element_id', type: 'Autocomplete', Autocomplete:combboxElements, placeholder:'Select PBS element', validation: 'required' },
    { key: 'system_subsystem_element_description', label: 'system_subsystem_element_description', type: 'input' },
    { key: 'HFI_or_LFI', label: 'HFI_or_LFI', type: 'select', SELECT_OPTIONS:HFI_LFI_OPTIONS, validation: 'required' },
    { key: 'author', label: 'author', type: 'input', validation: ['required'], placeholder:'author' },
    { key: 'verified_by', label: 'verified_by', type: 'input', placeholder:'verified_by', validation: 'required' },
  ];
  const defaultColumns2 = [
    { key: 'second_id', label: 'second_id', type: 'input', placeholder:'second id' },
    { key: 'paramName', label: 'paramName', type: 'input',  validation: 'required'},
    { key: 'paramValue', label: 'paramValue', type: 'input' },
    { key: 'paramUnit', label: 'paramUnit', type: 'input' },
    { key: 'paramMargin', label: 'paramMargin', type: 'input' },
    { key: 'paramType', label: 'paramType', type: 'input' },
    { key: 'description', label: 'description', type: 'input' },
    { key: 'ref', label: 'ref', type: 'input' },
    { key: 'comment', label: 'comment', type: 'input' },
    { key: 'identity', label: 'identity', type: 'select', SELECT_OPTIONS:Identity_OPTIONS },
    { key: 'impact_or_zaxis', label: 'impact_or_zaxis', type: 'input' },
  ];
  const defaultColumns3 = [
    { key: 'second_id', label: 'second_id', type: 'input', placeholder:'second id' },
    { key: 'paramName', label: 'paramName', type: 'input',  validation: 'required'},
    { key: 'paramValue', label: 'paramValue', type: 'input' },
    { key: 'paramUnit', label: 'paramUnit', type: 'input' },
    { key: 'paramMargin', label: 'paramMargin', type: 'input' },
    { key: 'paramType', label: 'paramType', type: 'input' },
    { key: 'description', label: 'description', type: 'input' },
    { key: 'ref', label: 'ref', type: 'input' },
    { key: 'comment', label: 'comment', type: 'input' },
    { key: 'identity', label: 'identity', type: 'select', SELECT_OPTIONS:Identity_OPTIONS },
    { key: 'impact_or_zaxis', label: 'impact_or_zaxis', type: 'input' },
  ];
  return (
    <div>
      <div style={{padding: "20px"}}>
        <h4 style={{color: "green"}}>
        V 1.1 (January 2026)
        </h4>
        <h4>
        MonPetitTableurET is the desktop version of this form. 
        Please select your preferred architecture from the options below:
        </h4>
        
        Windows
        <a href="https://cc-etgw.in2p3.fr/api/download/MonPetitTableurET-win_x64.rar/" 
        target="_blank"
        rel="noopener noreferrer"
        >
          <button className="label-btn">x_64</button>
        </a>
        <br/>
        Mac
        <a href="https://cc-etgw.in2p3.fr/api/download/MonPetitTableurET-mac_x64.rar/" 
        target="_blank"
        rel="noopener noreferrer"
        >
          <button className="label-btn">x_64</button>
        </a>
        <br/>
        Linux
        <a href="https://cc-etgw.in2p3.fr/api/download/MonPetitTableurET-linux_x64.rar/" 
        target="_blank"
        rel="noopener noreferrer"
        >
          <button className="label-btn">x_64</button>
        </a>
      </div>

      {error && <span style={{ color: "red" }}>{error}</span>}
      <div className="local">
        <EditableTable
          title="General Informations"
          columns={defaultColumns1}  
          params={params}
          setParams={setParams}
          validateRows = {validateRows}
          addRows = {false}
        />
        <div className="validation-label">
          {missingRequiredFields2.length === 0
            ? "All fields OK ✅"
            : `Missing required fields ⚠️: ${missingRequiredFields2.join(", ")}`}
        </div>
      </div>
      <EditableTable
          title="Functional Parameters"
          columns={defaultColumns2}  
          params={params2}
          setParams={setParams2}
          validateRows = {validateRows}
          addRows = {true}
          defaultValues={{identity: "Functional", paramValue: '0'}}
        />

        <div className="validation-label">
          {missingRequiredFields3.length === 0
            ? "All fields OK ✅"
            : `Missing required fields ⚠️: ${missingRequiredFields3.join(", ")}`}
        </div>

      <EditableTable
          title="Integration Parameters"
          columns={defaultColumns3}  
          params={params3}
          setParams={setParams3}
          validateRows = {validateRows}
          addRows = {true}
          defaultValues={{identity: "Integration", paramValue: '0'}}
        />
      

      <div style={{ textAlign: "center", marginTop: 20 }}>
        <button className = "default-btn" onClick={exportParamsFile} disabled={isExporting}>
          {isExporting ? "Exporting..." : "Download"}
        </button>
        {/* OR divider */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            margin: "16px 0",
            fontSize: "12px"
          }}
        >
          <div style={{ flex: 1, height: "1px", backgroundColor: "#ccc" }} />
          <span style={{ margin: "0 10px" }}>or</span>
          <div style={{ flex: 1, height: "1px", backgroundColor: "#ccc" }} />
        </div>
            
      </div>

      
      <div  style={{ display: "flex", justifyContent: "center", marginTop: 20, marginBottom:100 }}>
      <FileInput
        isBulk={false}
        labelSingle={`Upload .etgw`}
        accept=".etgw"
        uploadService={uploadFileService}
        onUploadComplete={(status) => {
          console.log("Single file status:", status);
          
          const res = status[0]?.response;
          setParams(res.data.data_infos || []);
          setParams2(res.data.Functional_Parameters || []);
          setParams3(res.data.Integration_Parameters || []);
        }}
      />  
      </div>
    </div>
  );
}

